import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import type {
  ConversationStarters,
  ConversationStartersContext,
} from '@core/tellent-assistant-types';
import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

@Injectable({ providedIn: 'root' })
export class ConversationStartersHttp {
  private readonly httpApi = injectTellentIntelligenceHttp();

  public fetch(ctx: ConversationStartersContext): Observable<ConversationStarters> {
    return this.httpApi
      .post('/tellent-assistant/context', null, ctx)
      .pipe(map((response): ConversationStarters => response.data));
  }
}
